import { render, staticRenderFns } from "./HeroSection.vue?vue&type=template&id=51be2812&scoped=true&"
import script from "./HeroSection.vue?vue&type=script&lang=js&"
export * from "./HeroSection.vue?vue&type=script&lang=js&"
import style0 from "./HeroSection.vue?vue&type=style&index=0&id=51be2812&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51be2812",
  null
  
)

export default component.exports